import React from "react";

import { type FundDataWithType } from "@hsl/fund-explorer/metaSchemas";

import { Translate } from "../../../hooks/useTranslation";
import useExplorerStore from "../../../store/store";
import Tabs from "../../Tabs";

interface Props {
    fund: FundDataWithType;
}

const AboutView = ({ fund }: Props) => {
    const config = useExplorerStore((state) => state.config);
    const UKFA = 78;
    const UKPI = 146;
    const { benchmark } = fund.data.data;
    const benchmarkStr =
        benchmark === "-" ? (
            <Translate>This fund has no benchmark</Translate>
        ) : (
            benchmark
        );
    const tabBenchmark = {
        key: "benchmark",
        label: <Translate>Benchmark</Translate>,
    };
    const tabIA = { key: "ia-sector", label: <Translate>IA Sector</Translate> };
    const hasSector =
        fund.type === "collective" &&
        typeof fund.data.data.sector === "string" &&
        fund.data.data.sector.length > 1;
    const tabs = hasSector ? [tabBenchmark, tabIA] : [tabBenchmark];
    const content = (
        hasSector ? [benchmarkStr, fund.data.data.sector] : [benchmarkStr]
    ).map((str) => <span className="text-left text-sm">{str}</span>);

    const defaultToSector =
        hasSector && [UKFA, UKPI].includes(config.audienceId);

    switch (fund.type) {
        case "etf":
        case "collective":
            return (
                <Tabs
                    tabs={tabs}
                    content={content}
                    tabClassName="text-sm"
                    type="text"
                    contentContainerClassName="pt-1 text-left leading-[0]"
                    containerClassName="pt-2"
                    scrollerClassName="overflow-y-hidden"
                    activeIndex={defaultToSector ? 1 : 0}
                />
            );
        case "pmc":
            return /^normal/gi.test(fund.data.data.card_variant) ? (
                <div className="pt-1 text-left text-sm">{benchmarkStr}</div>
            ) : (
                <></>
            );
        default:
            return null;
    }
};

export default AboutView;
